import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { lazy, Suspense } from "react";
import cls from "classnames";
import ClientSideComponent from "../ClientSideComponent";
import usePhoneNumberState from "./hooks/usePhoneNumberState";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var LazyComponent = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "shared-react-phone-input" */"./PhoneInput");
});
var LazyPhoneInput = function LazyPhoneInput(props) {
  var loader = /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.label ? /*#__PURE__*/_jsx("div", {
      className: cls('w-1/3 h-20 mb-8 bg-gray-dark-16 rounded-5', {
        'bg-gray-dark-16': props.isDark || props.isDarkMode
      })
    }) : null, /*#__PURE__*/_jsx("div", {
      className: cls('w-full h-56 mb-24 rounded-5', {
        'bg-gray-dark-16': props.isDark || props.isDarkMode
      })
    })]
  });
  return /*#__PURE__*/_jsx(ClientSideComponent, {
    fallback: loader,
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: loader,
      children: /*#__PURE__*/_jsx(LazyComponent, _objectSpread({}, props))
    })
  });
};
export { usePhoneNumberState };
export { LazyPhoneInput as PhoneInput };
export default LazyPhoneInput;